import * as React from 'react'

import {Button} from '@frontrow/console/src/components/button'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'

type Props = {
  show: boolean
  onStay: () => void
  onLeave: () => void
}

export default function SaveChangesModal(props: Props): React.ReactElement {
  const {show, onStay, onLeave} = props

  return (
    <Dialog
      open={show}
      onClose={onStay}
      backdrop={<div className={dialogStyles.backdrop} />}
      className={dialogStyles.dialog}
      portal
      unmountOnHide
      hideOnEscape={false}
      hideOnInteractOutside={false}
    >
      <div className={dialogStyles.header}>
        <DialogHeading className={dialogStyles.title}>Leave this page?</DialogHeading>
        <DialogDismiss className={dialogStyles.closeButton}>
          <span aria-hidden="true">&times;</span>
        </DialogDismiss>
      </div>
      <div className={dialogStyles.body}>
        <p>
          There are unsaved updates. Are you sure you want to leave this page without saving these
          changes?
        </p>
      </div>
      <div className={dialogStyles.footer}>
        <Button style="secondary" onClick={onStay}>
          No, Stay
        </Button>
        <Button onClick={onLeave} type="submit" style="primary">
          Yes, Leave
        </Button>
      </div>
    </Dialog>
  )
}
